import React from "react"

import Layout2 from "../components/layout2"
import SEO from "../components/seo"

import InternLinks from "../components/internlinks";
import { FaCheck } from 'react-icons/fa';

const IndexPage = () => (
  <Layout2>
     <SEO title="Smart 4500 3D Pink" description="Smart 4500 3D Pink" keywords={[`Oral B`, `Vita tänder`, `Eltandborste`, `Tandblekning hemma`, `Smart 4500 3D Pink`]}/>
     <section className="section-produkter">
       <article>
       <div className="prod-text">
          <h1>Oral B</h1>
         </div>
      </article>
      <article class="right">
        <img src="../oral-b-smart-4500.webp" alt="Smart 4500 3D Pink"/>
        <aside>
          <h3 class="erbj-pris">999:-</h3>
          <h2>Smart 4500 3D Pink</h2>
          <p class="prod-beskrivning">Det slanka vita handtaget på Smart 4-eltandborsten kan förbättra dina tandborstningsvanor.
          </p>
          <a href="https://ion.lyko.com/t/t?a=1117786221&as=1480987224&t=2&tk=1&url=https://lyko.com/sv/oral-b/oral-b-oral-b-smart-4500-3d-pink-" target="_blank" rel="noopener noreferrer" class="btn btn-warning btn-width">Beställ här</a>
          <ul>
             <li><FaCheck className="li-icon" />Guide i smartphone</li>
             <li><FaCheck className="li-icon" />Patenterad trycksensorteknik</li>
             <li><FaCheck className="li-icon" />Tar bort upp till 100 % mer plack</li>
          </ul>
        </aside>
        <div className="prod-text"><h5>Upplev Oral-B Smart 4500</h5>
         <p>Den tar bort upp till 100 % mer plack än en vanlig manuell tandborste, för friskare tandkött,
            och tar bort ytlig missfärgning för vitare tänder redan vid första användningen. Dessutom hjälper tandborsten dig att skydda det ömtåliga tandköttet med hjälp av den patenterade trycksensortekniken som drar ner på borstningshastigheten och gör dig uppmärksam på att borsta skonsammare om du borstar för hårt. Med Smart Coaching som du får av Oral-B Smart 4 kan du både förbättra dina borstningsvanor och din munhälsa. Inte undra på att Oral-B är det varumärke som flest tandläkare rekommenderar världen över</p></div>
      </article>

       </section>
       {/* <section className="section-cards">
    <main>
    <h2 class="rubrik-tandblekning">Bästa tandblekningen hemma</h2>
       <Card />
       </main>
  </section> */}

  <section className="section-cards card-height">
  <main>
      <h2 class="internal-rubrik">Bästa tandblekningen hemma</h2>
    <InternLinks />
    </main>
  </section>
  </Layout2>
)

export default IndexPage
